import { RootState } from '../../store';

export const getAvailableCategoriesSelector = (state: RootState) => state?.ticketReducer?.availableCategories;
